// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SRui8","input":"styles_input__5LiQz"};